import { getSangjoQuotations } from "@/apis/sangjoQuotation";

import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  GoiLogo,
  HStack,
  useResponsive,
  VStack,
  call,
  Image,
  HLine,
  icon,
  queryKeys,
  Spacing,
  EventTriggerAndTargetType,
  EventPathType,
  getPrimeUrl,
  getSharedMenuItems,
  FirstMenuItemProps,
  SecondMenuItemProps,
} from "goi_common";

import { isLoggedInState } from "@/atoms/accountState";
import { useRouter } from "next/router";
import { BaseStack, baseColors } from "goi_common/src/design-system";
import { Dispatch, SetStateAction, useMemo, useState } from "react";
import { useRecoilValue } from "recoil";

import dayjs from "dayjs";
import { useQuery } from "react-query";
import HeaderButton from "./HeaderButton";
import { MatchRecommenationQuotationType } from "@/containers/MatchContainer/type/MatchRecommendationType";

// interface FuneralGuideItemProps {
//   title: string;
//   image: string;
//   event: EventProps;
//   link: string;
//   onClose: () => void;
// }

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
}

// interface DrawerItemProps {
//   href: string;
//   icon?: ReactNode;
//   title: ReactNode;
//   event?: EventProps;
// }

function Menu({ isOpen, onClose }: MenuProps) {
  const router = useRouter();
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const { data: quotationData } = useQuery(queryKeys.sangjoQuotation, () => getSangjoQuotations(), {
    enabled: isLoggedIn,
  });
  const quotationId: Array<MatchRecommenationQuotationType> = useMemo(() => {
    if (!quotationData || !isLoggedIn) {
      return undefined;
    } else if (quotationData.quotations[0]) {
      return quotationData.quotations[0].id;
    } else {
      return undefined;
    }
  }, [quotationData, isLoggedIn]);
  const [currentFirstMenu, setCurrentFirstMenu] = useState("my");

  const { isBiggerThanMd } = useResponsive();

  const MENU_ITEMS = useMemo(() => {
    const items = getSharedMenuItems({ quotationId: quotationId as any });
    const quotation = items
      .find((item) => item.key === "my")
      ?.items.find((item) => item.key === "quotation");
    if (quotation) quotation.to = "/my/v3";
    return items;
  }, [quotationId]);

  const currentMenuItems = useMemo(() => {
    return MENU_ITEMS.find((item: FirstMenuItemProps) => item.key === currentFirstMenu)?.items;
  }, [currentFirstMenu, MENU_ITEMS]);
  // const { data } = useQuery(["funeral_reviews"], () => {
  //   return Axios.get("/sangjo_reviews/");
  // });

  // const viewReviewData = data?.data.results?.filter((item: any) => {
  //   return item.score >= 4;
  // })[0];

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay bg="rgba(0, 0, 0, 0.5)" />
      <DrawerContent width="100%!important" maxWidth={isBiggerThanMd ? "360px" : "100%"}>
        <DrawerHeader
          flexDirection="column"
          display="flex"
          alignItems="flex-start"
          justifyContent="center"
          p="13px 16px 13px 20px"
        >
          <HStack justifyContent="space-between" alignItems="center" width="100%" gap="16px">
            <HStack alignItems="center" gap={24} width="100%" justifyContent="space-between">
              <HStack alignItems="center" gap={8}>
                <GoiLogo size={30} color={colors.goiBlack} />
              </HStack>
              <HeaderButton
                path="gnb"
                type="RED"
                onClick={() => {
                  call("1666-9784");
                  // router.push("/funeral-prepare/1/");
                }}
                eventTrigger="hbg_srvc_rcmms-uv_funeral_prepare_1"
              >
                24시간 고객센터
              </HeaderButton>
            </HStack>
            <Box
              onClick={onClose}
              width="24px"
              style={{
                width: "24px",
                height: "24px",
                padding: "0px",
                margin: "0",
                background: "none",
              }}
            >
              <ColorIcon name="header-close" size={24} color={colors.gray900} />
            </Box>
          </HStack>
        </DrawerHeader>
        {/* <DrawerSpacer /> */}

        <DrawerBody p="0">
          <VStack gap="24px" padding="32px 20px">
            {/* 진입 버튼 두 개는 8px 로 붙이고, 아래 아이콘 메뉴와는 24px */}
            <BaseStack spacing={8} width="100%">
              <Box
                borderRadius="6px"
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="space-between"
                backgroundColor={colors.orange650}
                padding="16px 18px"
                width="100%"
                cursor="pointer"
                onClick={() => {
                  router.push("/my/v3");
                  customEvent({
                    newGtm: { path: "gnb", trigger_and_target: "mypage-uv_my_v3" },
                  });
                  onClose();
                }}
              >
                <span className="body_16_sb" css={{ color: colors.white, fontWeight: 700 }}>
                  나의 장례 준비 현황 확인하기
                </span>
                <ColorIcon name="chevron_right_24" size={24} color={colors.white} />
              </Box>
              <Box
                borderRadius="6px"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                backgroundColor={baseColors.fill_normal}
                padding="13px 16px"
                width="100%"
                cursor="pointer"
                onClick={() => {
                  router.push(getPrimeUrl("/prime-benefit/verify/?utm_campaign=platform_drawer"));
                  onClose();
                }}
              >
                <Box>
                  <Box className="caption_1_r" color={baseColors.label_assistive_1}>
                    고이 상조에 납부중이라면?
                  </Box>
                  <Box className="body_1_normal_m" color={baseColors.label_alternative_2}>
                    내 고이 상조 혜택 보러가기
                  </Box>
                </Box>
                <ColorIcon name="chevron_right_24" size={20} color={baseColors.label_assistive_1} />
              </Box>
            </BaseStack>
            <HStack width="100%">
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/coin.png")}
                title="100원 상조"
                onClick={() => {
                  router.push(getPrimeUrl(`/?utm_campaign=platform_gnb_drawer`));
                  customEvent({ newGtm: { path: "gdrwr", trigger_and_target: "main-prime" } });
                  onClose();
                }}
              />

              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/estimate_calculate.png")}
                title="장례 견적"
                onClick={() => {
                  router.push("/match/request");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-match_request" },
                  });

                  onClose();
                }}
              />
              <MainIconMenu
                iconSrc="/platform/home/facility_find_40.svg"
                title="시설 찾기"
                onClick={() => {
                  router.push("/funeral-facilities/");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-facility" },
                  });
                  onClose();
                }}
              />
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/write.png")}
                title="실제 후기"
                onClick={() => {
                  router.push("/review");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-review" },
                  });
                  onClose();
                }}
              />
              <MainIconMenu
                iconSrc={getCdnImageSrc("platform/home/headset.png")}
                title="임종 접수"
                onClick={() => {
                  call("1666-9784");
                  customEvent({
                    newGtm: { path: "gdrwr", trigger_and_target: "main-call" },
                  });
                }}
              />
            </HStack>
          </VStack>
          <HLine height="1px" color={colors.gray100} />
          <HStack background={colors.gray50} height="calc(100vh - 270px)">
            <LeftMenus
              menuItems={MENU_ITEMS}
              currentFirstMenu={currentFirstMenu}
              setCurrentFirstMenu={setCurrentFirstMenu}
            />
            {currentMenuItems && <RightMenus items={currentMenuItems} onClose={onClose} />}
          </HStack>
          {/* <VStack padding="0 24px 18px 0">
            <DrawerItem
              href="/service/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="drawer_goi_icon" size={32} color={""} />
                </Box>
              }
              title={
                <HStack gap="6px" alignItems="center">
                  <Box className="body_16_r">고이상조 서비스 전체 보기</Box>
                  <Badge
                    className="caption_11_sb"
                    color={colors.orange700}
                    backgroundColor={colors.orange150}
                    css={{
                      borderRadius: "11px",
                      padding: "4px 6px",
                    }}
                  >
                    사전상담 할인가
                  </Badge>
                </HStack>
              }
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-service" },
              }}
            />

            <DrawerItem
              href="/match/request/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="icon-document-search" size={32} color={""} />
                </Box>
              }
              title={<Box className="body_16_r">장례 전체 비용 견적, 맞춤형 혜택 알아보기</Box>}
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-mtch_rqst" },
              }}
            />

            <DrawerItem
              href="/guidebook/"
              icon={
                <Box margin="0 0 0 4px">
                  <ColorIcon name="book_has_bookmark" size={32} color="" />
                </Box>
              }
              title={<Box className="body_16_r">장례의 모든 정보, 무료 온라인 가이드북</Box>}
              event={{
                newGtm: { path: "gnb", trigger_and_target: "drawer-guidebook" },
              }}
            />
          </VStack> */}

          {/* <DrawerSpacer /> */}

          {/* <MenuReviewItem onClose={onClose} viewReviewData={viewReviewData} /> */}

          {/* <DrawerSpacer />

          <VStack overflow="hidden" padding="24px">
            <Box className="subtitle_18_sb">장례 준비, 제일 궁금한 점들을 모았어요</Box>

            <Box overflow="scroll">
              <HStack overflow="scroll" width="max-content" padding="16px 0px" gap="16px">
                {MENU_FUNERAL_GUIDE_ITEMS.map((item) => (
                  <MenuFuneralGuideItem key={item.link} {...item} onClose={onClose} />
                ))}
              </HStack>
            </Box>
          </VStack>
          <DrawerSpacer /> */}
        </DrawerBody>

        {/* <DrawerFooter padding="16px 24px">
          <VStack
            width="100%"
            height="60px"
            alignItems="center"
            justifyContent="center"
            background={colors.orange650}
            borderRadius="5px"
            color={colors.white}
            css={{
              cursor: "pointer",
            }}
            onClick={() => {
              call("1666-9784", true);
            }}
          >
            <HStack color={colors.white} alignItems="center" gap="6px">
              <ColorIcon color={colors.white} name="icon-call-mono" size={20} />
              <Box className="button_16_sb white">24시간 상담 / 임종 접수</Box>
            </HStack>
          </VStack>
        </DrawerFooter> */}
      </DrawerContent>
    </Drawer>
  );
}

// const DrawerSpacer = styled.div`
//   width: 100%;
//   height: 6px;
//   background: var(--gray50);
// `;

// const DrawerItemRoot = styled(NextLink)`
//   margin-left: 0;
//   display: flex;
//   align-items: center;
//   width: 100%;
//   height: 56px;
//   padding-left: 20px;
//   = :active {
//     background: var(--gray50);
//   }

//   .body3_m {
//     padding-left: 12px;
//   }
// `;

export const formatReviewDate = (date: Date) => {
  const created = dayjs(date);
  const now = dayjs();

  const diffDays = now.diff(created, "day");
  const diffHours = now.diff(created, "hour");
  const diffMinutes = now.diff(created, "minute");

  if (diffDays < 1) {
    if (diffHours < 1) {
      return { text: `${diffMinutes}분 전`, color: colors.orange650 };
    } else {
      return { text: `${diffHours}시간 전`, color: colors.orange650 };
    }
  } else if (diffDays < 4) {
    return { text: `${diffDays}일 전`, color: colors.orange650 };
  } else {
    return { text: created.format("YYYY.MM.DD"), color: colors.gray500 };
  }
};

export default Menu;

// export const MenuReviewItem = ({
//   onClose,
//   viewReviewData,
// }: {
//   onClose: () => void;
//   viewReviewData: any;
// }) => {
//   const router = useRouter();

//   return (
//     <VStack padding="24px" background={colors.white}>
//       <HStack justifyContent="space-between" alignItems="center">
//         <Box className="subtitle_18_sb gray900">
//           고이상조 이용 후기
//           {/* <sup className="subtitle_12_b orange650">NEW</sup> */}
//         </Box>
//         <HStack
//           gap={6}
//           css={{
//             cursor: "pointer",
//           }}
//           alignItems="center"
//           onClick={() => {
//             router.push("/review/");
//             customEvent({
//               newGtm: {
//                 path: "gnb",
//                 trigger_and_target: "review-uv_review",
//               },
//             });

//             onClose();
//           }}
//         >
//           <span className="body_14_r gray600">전체보기</span>
//           <ColorIcon name="arrow_forward_rounded" color={colors.gray600} size={13} />
//         </HStack>
//       </HStack>

//       <HStack gap={12} width="100%" margin="12px 0 0 0">
//         {viewReviewData && (
//           <VStack
//             padding="16px 20px"
//             background={colors.gray50}
//             borderRadius="6px"
//             width="100%"
//             gap="10px"
//             css={{
//               cursor: "pointer",
//             }}
//             onClick={() => {
//               customEvent({
//                 newGtm: {
//                   path: "gnb",
//                   trigger_and_target: "recent_review-uv_review_detail",
//                   text: String(viewReviewData.id),
//                 },
//                 triggerHackle: true,
//               });
//               router.push(`/review/${viewReviewData.id}/`);
//               onClose();
//             }}
//           >
//             <HStack alignItems="center" justifyContent="space-between">
//               <HStack alignItems="center" gap="4px">
//                 <Box>
//                   <ColorIcon name="rating_star" size={14} color={colors.orange650} />
//                 </Box>
//                 <Box className="subtitle_14_b gray900">{viewReviewData.score}.0</Box>

//                 <Box className="caption_11_r gray500">
//                   | {`${viewReviewData.user.age_and_gender} ` || ""}
//                   {viewReviewData.user.nickname}님
//                 </Box>
//               </HStack>
//               <Box
//                 className={"caption_11_r"}
//                 color={formatReviewDate(viewReviewData.created_at).color}
//               >
//                 {formatReviewDate(viewReviewData.created_at).text}
//               </Box>
//             </HStack>

//             <VStack position="relative" gap="4px">
//               <Box
//                 className="body_14_r gray900"
//                 css={{
//                   display: "-webkit-box",
//                   WebkitLineClamp: 3,
//                   WebkitBoxOrient: "vertical",
//                   overflow: "hidden",
//                   maxWidth: "100%",
//                 }}
//               >
//                 {viewReviewData.good}
//               </Box>
//               {viewReviewData.good.length > 80 && (
//                 <Box
//                   className="caption_12_r gray500"
//                   cursor="pointer"
//                   onClick={() => {
//                     customEvent({
//                       newGtm: {
//                         path: "gnb",
//                         trigger_and_target: "recent_review-uv_review_detail",
//                         text: String(viewReviewData.id),
//                       },
//                       triggerHackle: true,
//                     });
//                     router.push(`/review/${viewReviewData.id}/`);
//                     onClose();
//                   }}
//                 >
//                   더보기
//                 </Box>
//               )}
//             </VStack>
//           </VStack>
//         )}
//       </HStack>
//     </VStack>
//   );
// };

const MainIconMenu = ({
  iconSrc,
  title,
  onClick,
}: {
  iconSrc: string;
  title: string;
  onClick: () => void;
}) => {
  return (
    <VStack gap="6px" alignItems="center" width="100%" onClick={onClick}>
      <Image src={iconSrc} width={48} />
      <Box className="body_14_r gray900" width="100%" textAlign="center">
        {title}
      </Box>
    </VStack>
  );
};

const LeftMenus = ({
  menuItems,
  currentFirstMenu,
  setCurrentFirstMenu,
}: {
  menuItems: FirstMenuItemProps[];
  currentFirstMenu: string;
  setCurrentFirstMenu: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <VStack width="116px">
      {menuItems.map((item) => {
        return (
          <Box
            padding="16px 20px"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "gdrwr",
                  trigger_and_target: `1_${item.key}` as EventTriggerAndTargetType[EventPathType],
                },
              });
              setCurrentFirstMenu(item.key);
            }}
            key={item.key}
            className={`${
              currentFirstMenu === item.key ? "subtitle_16_sb gray900" : "body_16_r gray700"
            }`}
            background={currentFirstMenu === item.key ? colors.white : colors.gray50}
          >
            {item.title}
          </Box>
        );
      })}
    </VStack>
  );
};

const RightMenus = ({ items, onClose }: { items: SecondMenuItemProps[]; onClose: () => void }) => {
  const router = useRouter();
  return (
    <VStack padding="16px" background="white" flexGrow={1} overflow="scroll">
      {items.map((childItem, index) => {
        return (
          <VStack
            key={childItem.key}
            onClick={() => {
              if (childItem.to) {
                customEvent({
                  newGtm: {
                    path: "gdrwr",
                    trigger_and_target:
                      `2_${childItem.key}` as EventTriggerAndTargetType[EventPathType],
                  },
                });
                router.push(childItem.to).finally(() => {
                  onClose();
                });
              }
            }}
          >
            <SecondMenuItem item={childItem} onClose={onClose} />
            {index !== items.length - 1 && (
              <>
                <Spacing gap={12} />
                <HLine height="1px" color={colors.gray100} />
                <Spacing gap={12} />
              </>
            )}
          </VStack>
        );
      })}
    </VStack>
  );
};

const SecondMenuItem = ({ item, onClose }: { item: SecondMenuItemProps; onClose: () => void }) => {
  const router = useRouter();
  return (
    <VStack>
      <HStack padding="12px 0" gap="6px">
        {item.iconName && (
          <ColorIcon name={item.iconName as keyof typeof icon} color="" size={24} />
        )}
        <HStack justifyContent="space-between" width="100%">
          <Box className="subtitle_16_sb gray900">{item.title}</Box>
          {item.to && <ColorIcon name="chevron_right_24" size={24} color={colors.gray700} />}
          {item.items && <ColorIcon name="chevron_up_24" size={24} color={colors.gray700} />}
        </HStack>
      </HStack>
      {item.items && (
        <VStack margin="8px 0 0 0">
          {item.items?.map((childItem) => {
            return (
              <HStack
                key={childItem.key}
                gap="6px"
                padding="12px 0"
                onClick={() => {
                  if (childItem.to) {
                    customEvent({
                      newGtm: {
                        path: "gdrwr",
                        trigger_and_target:
                          `3_${item.key}_${childItem.key}` as EventTriggerAndTargetType[EventPathType],
                      },
                    });

                    router.push(childItem.to).finally(() => {
                      onClose();
                    });
                  }
                }}
                alignItems="center"
              >
                <Box className="body_16_r gray700">{childItem.title}</Box>
                {childItem.tag && (
                  <Box
                    padding="2px 8px"
                    borderRadius="13px"
                    className="caption_11_m orange700"
                    background={colors.orange150}
                  >
                    {childItem.tag}
                  </Box>
                )}
              </HStack>
            );
          })}
        </VStack>
      )}
    </VStack>
  );
};
